import { PaymentCompany } from "../payment/paymentCompany";

export class PaymentEmailRequest{

    public OrderId: string;
    public CustomerId: number;
    public EmailType: number;
    public Comment: string;
    public Amount: number;
    public CurrencyCode: string;
    public FileNumber: string;
    public AgentUserId: number;
    public CargoWiseOrganizationCode: string;
    public PaymentCompany: PaymentCompany;

    public constructor(init?: Partial<PaymentEmailRequest>) {
        Object.assign(this, init);
    }
}



// WEBPACK FOOTER //
// ./app/objects/email/PaymentEmailRequest.ts